"use client";
import React, { useState } from "react";
import { PublicationCard } from "@/components/PublicationCard";
import { ScrollReveal } from "@/components/ScrollReveal";

interface Pub {
  id: string;
  title: string;
  authors: string;
  venue: string;
  year: string;
  url?: string;
}

export function PublicationFilter({ publications }: { publications: Pub[] }) {
  const [filter, setFilter] = useState<"all" | string>("all");

  const uniqueAuthors = Array.from(
    new Set(
      publications
        .flatMap((p) => p.authors.split(", ").map((a) => a.trim()))
        .filter(Boolean)
    )
  ).sort();

  const filtered =
    filter === "all"
      ? publications
      : publications.filter((p) =>
          p.authors
            .split(", ")
            .some((a) => a.trim().toLowerCase() === filter.toLowerCase())
        );

  return (
    <>
      <ScrollReveal delay={100}>
        <div className="mb-12">
          <select
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
            className="rounded-full border border-[var(--color-border)] bg-[var(--color-surface-elevated)] px-5 py-3 text-sm font-medium text-[var(--color-ink)] transition-all duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--color-accent)] focus-visible:ring-offset-2 hover:border-[var(--color-accent)]"
          >
            <option value="all">Show All</option>
            {uniqueAuthors.map((author) => (
              <option key={author} value={author}>
                {author}
              </option>
            ))}
          </select>
        </div>
      </ScrollReveal>

      <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
        {filtered.map((pub, i) => (
          <ScrollReveal key={pub.id} delay={i * 80}>
            <PublicationCard
              title={pub.title}
              authors={pub.authors}
              venue={pub.venue}
              year={Number(pub.year) || 0}
              citationHref={pub.url}
            />
          </ScrollReveal>
        ))}
      </div>
    </>
  );
}
